import { render, staticRenderFns } from "./CrearScriptModal.vue?vue&type=template&id=521c56b3&scoped=true&"
import script from "./CrearScriptModal.vue?vue&type=script&lang=ts&"
export * from "./CrearScriptModal.vue?vue&type=script&lang=ts&"
import style0 from "./CrearScriptModal.vue?vue&type=style&index=0&id=521c56b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c56b3",
  null
  
)

export default component.exports